module.exports = __webpack_public_path__ + "img/snpark_gallery2.7862dcf8.jpg";